import React, { useState } from 'react';
import { HiXMark, HiCheckCircle } from 'react-icons/hi2';

const TemplateBuyModal = ({ isOpen, onClose, template }) => {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    website: '',
    plan: 'full',
  });

  if (!isOpen) return null;

  const templateName = template?.name || 'Website Template';
  const price = template?.price || '$299';

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  const handleClose = () => {
    setSubmitted(false);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-md p-4 animate-fadeIn">
      <div className="relative w-full max-w-lg bg-[#f9f9f5] text-[#1C1917] rounded-md shadow-2xl p-6 sm:p-8 border border-[#E5E0D8]">

        <button
          onClick={handleClose}
          className="absolute top-4 right-4 p-1 text-stone-500 hover:text-stone-900 transition-colors rounded-xs cursor-pointer"
        >
          <HiXMark className="w-6 h-6" />
        </button>

        {submitted ? (
          <div className="text-center py-8">
            <HiCheckCircle className="w-16 h-16 text-emerald-600 mx-auto mb-4" />
            <h3 className="font-gildaDisplay text-3xl text-[#1C1917] mb-2">
              Thank You!
            </h3>
            <p className="font-josefinSans text-base text-[#57534E] mb-6">
              Your inquiry for <strong>{templateName}</strong> has been received. Our team will contact you within 24 hours with complete setup details.
            </p>
            <button
              onClick={handleClose}
              className="px-6 py-3 bg-[#1C1917] text-white font-montserratMedium text-[9px] lg:text-[11px] uppercase tracking-widest font-semibold rounded-xs hover:bg-[#ccc3ad] hover:text-black duration-[0.5s] transition-colors cursor-pointer"
            >
              CLOSE
            </button>
          </div>
        ) : (
          <div>
            <div className="mb-6 pb-4 border-b border-[#E5E0D8]">
              <span className="font-zalandoSansExpanded text-[10px] uppercase tracking-[0.25em] text-[#78716C] font-semibold block mb-1">
                INSTANT ACCESS / INQUIRY
              </span>
              <h3 className="font-gildaDisplay text-2xl sm:text-3xl text-[#1C1917]">
                Get {templateName}
              </h3>
              <p className="font-josefinSans text-sm text-[#57534E] mt-1">
                Price: <strong className="text-[#1C1917]">{price}</strong> • Instant Setup & Download
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block font-zalandoSansExpanded text-[10px] uppercase tracking-wider font-semibold text-[#1C1917] mb-1">
                  Full Name *
                </label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="Jane Doe"
                  className="w-full px-3.5 py-2.5 bg-white border border-[#D8D2C7] rounded-xs text-sm font-josefinSans text-[#1C1917] focus:outline-none focus:border-[#1C1917]"
                />
              </div>

              <div>
                <label className="block font-zalandoSansExpanded text-[10px] uppercase tracking-wider font-semibold text-[#1C1917] mb-1">
                  Email Address *
                </label>
                <input
                  type="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="jane@example.com"
                  className="w-full px-3.5 py-2.5 bg-white border border-[#D8D2C7] rounded-xs text-sm font-josefinSans text-[#1C1917] focus:outline-none focus:border-[#1C1917]"
                />
              </div>

              <div>
                <label className="block font-zalandoSansExpanded text-[10px] uppercase tracking-wider font-semibold text-[#1C1917] mb-1">
                  Current Website (Optional)
                </label>
                <input
                  type="text"
                  value={formData.website}
                  onChange={(e) => setFormData({ ...formData, website: e.target.value })}
                  placeholder="https://mybrand.com"
                  className="w-full px-3.5 py-2.5 bg-white border border-[#D8D2C7] rounded-xs text-sm font-josefinSans text-[#1C1917] focus:outline-none focus:border-[#1C1917]"
                />
              </div>

              <div>
                <label className="block font-zalandoSansExpanded text-[10px] uppercase tracking-wider font-semibold text-[#1C1917] mb-1">
                  Payment Option
                </label>
                <select
                  value={formData.plan}
                  onChange={(e) => setFormData({ ...formData, plan: e.target.value })}
                  className="w-full px-3.5 py-2.5 bg-white border border-[#D8D2C7] rounded-xs text-sm font-josefinSans text-[#1C1917] focus:outline-none focus:border-[#1C1917]"
                >
                  <option value="full">Pay in Full ({price})</option>
                  <option value="split">Split Payment Plan (3 x $75/mo)</option>
                </select>
              </div>

              <button
                type="submit"
                className="w-full mt-4 py-3.5 bg-[#1C1917] text-white font-montserratMedium text-[9px] lg:text-[11px] uppercase tracking-[0.2em] font-bold rounded-xs hover:bg-[#ccc3ad] hover:text-black duration-[0.5s] transition-colors cursor-pointer"
              >
                PROCEED TO PURCHASE ({price})
              </button>
            </form>
          </div>
        )}

      </div>
    </div>
  );
};

export default TemplateBuyModal;
